import applogo from 'assets/images/choicehotels.jpg'
import onboarding from 'assets/images/TCLogo.jpg'
import Card from 'components/molecules/Card/Card'
import FormModal from 'components/organisms/FormModal/FormModal'
import * as FormConst from 'constants/FormConst'
import SessionConst from 'constants/SessionConst'
import { isEmptyObject } from 'jquery'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import HotelInfoService from 'services/HotelInfoService'
import OnboardingContactService from 'services/OnboardingContactService'
import { getBrandLogo } from 'utilities/FormHelper'
import { getCurrentDateString, isArrayNotEmpty, isObjectEmpty } from 'utilities/JSUtil'
import { getSessionItem } from 'utilities/SessionHelper'
import RouteConst from '../../constants/RouteConst'
import { asyncMethod } from '../../redux/actions'
import * as actionTypes from '../../redux/actionTypes'
import Button from '../atoms/Button/Button'
import './TermsAndConditions.scss'

/**
 * Component that displays the terms and conditions that need to be accepted by the user.
 * Accessible by Hotel Contacts only.
 * Can be displayed when a new application begins 
 * or when Terms and Conditions version info is missing from the onboarding application status information.
 */
class TermsAndConditions extends Component {

  constructor(props) {
    super(props)

    window.scrollTo(0, 100)

    const user = getSessionItem(SessionConst.USER)
    const hotelCode = this.props.location?.state?.hotelCode

    if (!hotelCode) {
      //Redirect to home page
      this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
    }


    this.state = {
      hotelCode: this.props.location?.state?.hotelCode,
      onboardingStatus: this.props.location?.state?.onboardingStatus,
      basicHotelInfo: {},
      loadingMessage: 'Retrieving Hotel Information',
      isLoading: true,
      isAgreeTermsAndConditionsCheck: false,
      user: user
    }
  }

  async componentDidMount() {
    await HotelInfoService.getBasicHotelInfo({
      hotelCode: this.state.hotelCode
    }).then(async (response) => {
      let onboardingContact
      await OnboardingContactService.getOnboardingContact({
        hotelCode: this.state.hotelCode
      }).then(onboardingContactResponse => {
        if (isArrayNotEmpty(onboardingContactResponse.contacts)) {
          onboardingContact = onboardingContactResponse.contacts[0]
        }

      }).catch((error) => {
        // No onboarding contact
      })

      this.setState({
        basicHotelInfo: response,
        isLoading: false,
        onboardingContact: onboardingContact
      })

    }).catch((error) => {
      // Redirect to search page
      this.setState({
        showErrorModal: true,
        errorMessage: 'System error. Please try again later.'
      })
    })
  }

  choiceFamilyText = ` To The`

  handleIsAgreeTermsAndConditionsCheckChange = () => {
    this.setState({
      isAgreeTermsAndConditionsCheck: !this.state.isAgreeTermsAndConditionsCheck
    })
  }

  redirectToLaunchOnboardingApplication = () => {
    let status = this.state.onboardingStatus

    switch (this.state.action) {
      case FormConst.ACTION_START_APPLICATION:
        status = FormConst.STATUS_IN_PROGRESS
        break
      case FormConst.ACTION_START_REVIEW:
        status = FormConst.STATUS_UNDER_REVIEW
    }

    this.props.history.push({
      pathname: RouteConst.ROUTE_LAUNCH_ONBOARDING_APPLICATION_PAGE,
      state: {
        hotelCode: this.state.hotelCode,
        onboardingStatus: {
          ...this.state.onboardingStatus,
          status: status
        }
      }
    })
  }

  redirectToUpdateOnboarding = (action) => {
    this.props.history.push({
      pathname: RouteConst.ROUTE_UPDATE_ONBOARDING_PAGE,
      state: {
        hotelCode: this.state.hotelCode,
        basicHotelInfo: this.state.basicHotelInfo,
        action: action
      }
    })
  }

  handleUpdateOnboarding = () => {
    if (!this.state.onboardingStatus) {
      this.props.onPost({
        hotelCode: this.state.hotelCode,
        version: FormConst.TERMS_AND_CONDITIONS_VERSION
      })

      this.setState({
        isLoading: true,
        loadingMessage: 'Creating Onboarding Application',
        actionPerformed: FormConst.ACTION_CREATE_APPLICATION
      })
    } else {
      this.props.onPutTermsAndConditions({
        hotelOnboardingId: this.state.onboardingStatus.hotelOnboardingId,
        formData: {
          hotelCode: this.state.hotelCode,
          hotelOnboardingId: this.state.onboardingStatus.hotelOnboardingId,
          version: FormConst.TERMS_AND_CONDITIONS_VERSION,
          acceptedBy: this.state.user.username,
          acceptedAt: getCurrentDateString() + 'T00:00:00',
          actionPerformed: FormConst.ACTION_UPDATE_TERMS_AND_CONDITIONS
        }
      })

      this.setState({
        isLoading: true,
        loadingMessage: 'Updating Terms and Conditions'
      })
    }

  }

  componentDidUpdate(prevProps) {

    if (prevProps.count !== this.props.count) {
      // Http request completed - Only PUT in this page, so check for response

      if (this.props.errorMessage) {
        this.setState({ isLoading: false, showErrorModal: true, actionPerformed: undefined })
      } else {
        if (this.state.actionPerformed === FormConst.ACTION_CREATE_APPLICATION) {
          this.redirectToUpdateOnboarding(FormConst.ACTION_START_APPLICATION)
        } else {
          if (this.state.onboardingStatus.status === FormConst.STATUS_GENERATED) {
            this.redirectToUpdateOnboarding(FormConst.ACTION_START_APPLICATION)
          } else {
            this.redirectToLaunchOnboardingApplication()
          }
        }
      }
    }
  }


  render() {

    // The text area with the terms and conditions
    let agreementDetails = <textarea
      className='terms-text-area'
      rows='10'
      defaultValue={FormConst.TERMS_AND_CONDITIONS}
      readOnly />

    // Basic hotel information
    let isEmptyBasicHotelInfo = isEmptyObject(this.state.basicHotelInfo)

    let brandLogo = isEmptyBasicHotelInfo
      ? <></>
      : <img className='brand-logo-img' src={getBrandLogo(this.state.basicHotelInfo)} />

    return (
      <div className='terms-and-conditions-page'>
        {/* Page logo */}
        <img id='terms-and-conditions-page-logo' src={onboarding} className='onboarding-img' />
        {/* Brand logo */}
        {brandLogo}
        {/* Welcome text */}
        <h3 id='terms-and-conditions-page-welcome-text' className='welcome-text'>
          Welcome {this.state.hotelCode} - {this.state.basicHotelInfo.hotelName}
        </h3>
        <div className='welcome-text-line2'>
          <h3 id='terms-and-conditions-page-family-text-pre'>{this.choiceFamilyText}</h3>
          <img id='terms-and-conditions-page-choice-logo' src={applogo} className='applogo-img' />
          <h3 id='terms-and-conditions-page-family-text-post'> Family </h3>
        </div>

        {/* Basic Hotel Info */}
        {
          !isEmptyBasicHotelInfo
          && <Card header='Hotel Information' className='basic-hotel-info-card' text={
            <dl className='basic-hotel-info-list'>
              <dt>Hotel Name</dt>
              <dd>{this.state.basicHotelInfo.hotelName}</dd>
              <dt>Hotel Code</dt>
              <dd>{this.state.basicHotelInfo.hotelCode}</dd>
              <dt>Phone Number</dt>
              <dd>
                {isArrayNotEmpty(this.state.basicHotelInfo.phones)
                  ? `+${this.state.basicHotelInfo.phones[0].countryAccessCode} (${this.state.basicHotelInfo.phones[0].areaCode}) - ${this.state.basicHotelInfo.phones[0].phoneNumber}`
                  : 'Not available'
                }
              </dd>
              <dt>Number of Rooms</dt>
              <dd>{this.state.basicHotelInfo.guestRooms}</dd>
              <dt>Number of Floors</dt>
              <dd>{this.state.basicHotelInfo.floors}</dd>
              {
                !isObjectEmpty(this.state.onboardingContact)
                && <>
                  <dt>Choice Onboarding Contact</dt>
                  <dd>
                    {this.state.onboardingContact.firstName + ' ' + this.state.onboardingContact.lastName}
                    <br />
                    {
                      isArrayNotEmpty(this.state.onboardingContact.phoneNumbers)
                        ? <>
                          {`+${this.state.onboardingContact.phoneNumbers[0].countryCode} (${this.state.onboardingContact.phoneNumbers[0].areaCode}) - ${this.state.onboardingContact.phoneNumbers[0].number}`}
                          <br />
                        </>
                        : <></>
                    }
                    {
                      isArrayNotEmpty(this.state.onboardingContact.emailAddresses)
                        ? <>{this.state.onboardingContact.emailAddresses[0].address}</>
                        : <></>
                    }
                  </dd>
                </>
              }
            </dl>
          } />
        }

        {/* Terms and conditions text */}
        <div id='terms-and-conditions-page-terms' className='textbox'>
          {agreementDetails}
        </div>
        <br />

        {/* Warning text */}
        <p className='text-red text-bold'>
          If your Hotel Information at the top of the screen is incorrect, DO NOT PROCEED and reach out to your {FormConst.LABEL_HOTEL_CONTACT_TYPE_OPENING_SERVICE_DIRECTOR}
        </p>

        {/* Checkbox for agreeing to the terms and conditions */}
        <div className='agree-action'>
          <input
            id='terms-and-conditions-page-checkbox'
            type='checkbox'
            className='agree-checkbox'
            onClick={this.handleIsAgreeTermsAndConditionsCheckChange} />
          <span id='terms-and-conditions-page-checkbox-text' className='terms-and-conditions-page-checkbox-text'>I agree to the terms and conditions</span>
        </div>
        {/* Confirm button */}
        <div className='confirm-button'>
          <Button
            id='terms-and-conditions-page-action-button'
            name='Begin onboarding'
            role='action'
            disabled={!this.state.isAgreeTermsAndConditionsCheck}
            onClick={this.handleUpdateOnboarding} />
        </div>

        {/* Form modals */}
        <FormModal
          id='new-onboarding-application-loading-modal'
          title={FormConst.MODAL_UPDATE_ACTION_TITLE}
          hotelInfo={this.state.basicHotelInfo}
          body={<h6>{this.state.loadingMessage}</h6>}
          show={this.state.isLoading}
          isLoadingIndicator />
        <FormModal
          id='new-onboarding-application-error-modal'
          hotelInfo={this.state.basicHotelInfo}
          title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
          body={<h5>{FormConst.MODAL_READ_ACTION_ERROR_TEXT}</h5>}
          isError
          cancel={() => { this.props.history.push(RouteConst.ROUTE_HOME_PAGE) }}
          show={this.state.showErrorModal} />
      </div>
    )
  }
}

// Map redux state to props
const mapStateToProps = state => {
  return {
    hotelInfoResponse: state.reducer.response,
    errorMessage: state.reducer.errorMessage,
    errorDescription: state.reducer.errorDescription,
    count: state.reducer.count
  }
}

// Map redux dispatch actions to props
const mapDispatchToProps = dispatch => {
  return {
    onGet: (hotelCode) => dispatch(asyncMethod(FormConst.FORM_TERMS_AND_CONDITIONS_NAME, actionTypes.ASYNC_ACTIONS.GET, { hotelCode: hotelCode })),
    onPost: (data) => dispatch(asyncMethod(FormConst.FORM_TERMS_AND_CONDITIONS_NAME, actionTypes.ASYNC_ACTIONS.POST, data)),
    onPutTermsAndConditions: (data) => dispatch(asyncMethod(FormConst.FORM_TERMS_AND_CONDITIONS_NAME, actionTypes.ASYNC_ACTIONS.PUT, data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TermsAndConditions)